import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAccountingCXCPReport } from "src/models/Accounting/AccountingReports.models";

interface AccountingCXCPReportState {
    cxcpReports: IAccountingCXCPReport[];
}

const initialState: AccountingCXCPReportState = {
    cxcpReports: [],
};

const AccountingCXCPReportSlice = createSlice({
    name: "AccountingCXCPReport",
    initialState,
    reducers: {
        setAccountingCXCPReportList: (
            state,
            action: PayloadAction<IAccountingCXCPReport[]>
        ) => {
            state.cxcpReports = action.payload;
        },
        concatListAccountingCXCPReport: (
            state: AccountingCXCPReportState,
            action: PayloadAction<IAccountingCXCPReport[]>
        ) => {
            state.cxcpReports = [...state.cxcpReports.concat(action.payload)];
        },
    },
});

export const {
    setAccountingCXCPReportList,
    concatListAccountingCXCPReport
} = AccountingCXCPReportSlice.actions;

export default AccountingCXCPReportSlice.reducer;